
const en_US = {
    "global.webName": "HadaPass Platform Merchant Portal",
    "global.filterBtn": "Filter",
    "global.addBtn": "Create",
    "global.backBtn": "Back",
    "global.male": "Male",
    "global.female": "Female",
    "global.apiError": "unknown error, please try again",
    "global.apiEditSuccess": "edit success!",
    "global.apiaddSuccess": "create success!",
    "global.apidelSuccess": "delete success!",
    "global.apisendSuccess": "send success!",
    "global.confirmDelModalTitle": "Delete Items",
    "global.systemLandingTitle": "Welcome back to HadaPass Platform Admin portal",
    "global.systemLandingMessage": "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed qu",
    "global.copyright": "Copyright @ 2024 BCNetcom. All Rights Reserved",
    "global.confirmModalTitle": "Warming",
    "global.delete": "Delete",

    "form.isRequired": "{name} is required!",
    "form.isValid": "please input a valid {name}",
    "form.placeholder": "Please enter {name}",
    "form.select": "select",
    "form.cancel": "Cancel",
    "form.ok": "Save",
    "form.delete": "Delete",
    "form.okBtn": "OK",
    "form.email": "Email",
    "form.emailPlaceholder": "email",
    "form.password": "Password",
    "form.passwordPlaceholder": "password",
    "form.confirmPassword": "Confirm password",
    "form.confirmPasswordPlaceholder": "confirm password",
    "form.verificationCode": "Verification code",
    "form.verificationCodePlaceholder": "verification code",
    "form.firstnamePlaceholder": "firstname",
    "form.firstname": "Firstname",
    "form.firstnamePlaceholder": "firstname",
    "form.lastname": "Lastname",
    "form.lastnamePlaceholder": "lastname",
    "form.role": "Role",
    "form.timeZone": "Time Zone",
    "form.reset": "Reset",
    "form.company": "Merchant company",
    "form.company": "Company",
    "form.companyPlaceholder": "company",
    "form.contactEmail": "Contact email",
    "form.phone": "Phone",
    "form.phonePlaceholder": "phone",
    "form.contactPhone": "Contact phone",
    "form.vendorContactEmail": "Vendor contact email",
    "form.vendorContactPhone": "Vendor contact phone",
    "form.serviceCode": "Service code",
    "form.serviceCodePlaceholder": "Service code",
    "form.serviceName": "Service name",
    "form.serviceNamePlaceholder": "service name",
    "form.enabled": "enabled",
    "form.disabled": "disabled",
    "form.active": "Active",
    "form.year": "year",
    "form.month": "month",
    "form.day": "day",
    "form.planRangePlaceholder": "plan range",
    "form.planRange": "Plan range",
    "form.planName": "Plan name",
    "form.planNamePlaceholder": "plan name",
    "form.planRangeUnit": "Plan range unit",
    "form.serviceAlias": "Service alias",
    "form.planEndDate": "Plan end date",
    "form.planStartDate": "Plan start date",
    "form.planExtendDate": "Plan extend date",
    "form.merchantServiceId": "Merchant service",
    "form.serviceStartDate": "Service start date",
    "form.serviceEndDate": "Service end date",
    "form.confCode": "Conf code",
    "form.confCodePlaceholder": "conf code",
    "form.confName": "Conf name",
    "form.confNamePlaceholder": "conf name",
    "form.apiGateway": "Api gateway",
    "form.apiGatewayPlaceholder": "api gateway",
    "form.frontendApiGateway": "Frontend api gateway",
    "form.frontendApiGatewayPlaceholder": "frontend api gateway",
    "form.status": "Status",
    "form.roleName": "Role name",
    "form.roleNamePlaceholder": "role name ",
    "form.all": "All",
    "form.Username": "User name",
    "form.UsernamePlaceholder": "user name",
    "form.UserRoleName": "User role name",
    "form.UserRoleNamePlaceholder": "user role name",
    "form.merchantCode": "Merchant code",
    "form.merchantCodePlaceholder": "merchant code",
    "form.merchantFrontendUrl": "Merchant frontend url",
    "form.merchantFrontendUrlPlaceholder": "merchant frontend url",
    "form.vendorMerchantId": "Vendor merchant",
    "form.merchantId": "Merchant",
    "form.vendorCode": "Vendor code",
    "form.vendorCodePlaceholder": "vendor code",
    "form.vendorName": "Vendor name",
    "form.vendorNamePlaceholder": "vendor name",
    "form.isMarketplace": "Is market place",
    "form.nickName": "Nick name",
    "form.nickNamePlaceholder": "nick name",
    "form.value": "Value",
    "form.valuePlaceholder": "value",
    "form.merchantName": "Merchant name",
    "form.merchantNamePlaceholder": "merchant name",
    "form.codePlaceholder": "code",
    "form.phoneArea": "Phone area",
    "form.fieldCode": "Field code",
    "form.fieldCodePlaceholder": "field code",
    "form.fieldType": "Field type",
    "form.isPrimary": "Is primary",

    "form.isRequestMandatory": "Is request mandatory",
    "form.code": "code",
    "form.title": "Title",
    "form.titlePlaceholder": "title",
    "form.cardNo": "Card No",
    "form.cardNoPlaceholder": "card No",
    "form.expiredDate": "Expired date",
    "form.userName": "User name",
    "form.userNamePlaceholder": "user name",
    "form.currentPassword": "currentPassword",
    "form.currentPasswordPlaceholder": "Current password",
    "form.type": "Type",
    "form.id": "Id",
    "form.idPlaceholder": "id",
    "form.scheduleAt": "Schedule At",
    "form.content": "Content",
    "form.contentPlaceholder": "content",
    "form.scheduleAtPlaceholder": "Schedule At",

    "frontendUser.nickName": "Nick Name",
    "frontendUser.nick_name": "Nick Name",

    "frontendUser.sex": "Sex",
    "frontendUser.country": "Country",
    "frontendUser.dob": "Dob",
    "frontendUser.gps": "GPS",
    "frontendUser.email": "Email",
    "frontendUser.emailVerified": "Email Verified",
    "frontendUser.phone": "Phone",
    "frontendUser.phoneVerified": "Phone Verified",
    "frontendUser.createdAt": "Account Created",
    "frontendUser.updatedAt": "Last Modified",
    "frontendUser.action": "Action",
    "frontendUser.deleteMerchant": "Delete Merchant",
    "frontendUser.entityId": "Entity Id",

    "frontendUserDetail.CardList": "Card List",
    "frontendUserDetail.back": "Back",

    "frontendUserPrimaryFieldAuth.value": "Value",
    "frontendUserPrimaryFieldAuth.userId": "User Id",
    "frontendUserPrimaryFieldAuth.type": "Type",
    "frontendUserPrimaryFieldAuth.isVerified": "Is Verified",
    "frontendUserPrimaryFieldAuth.lastVerifiedAt": "Last VerifiedAt",
    "frontendUserPrimaryFieldAuth.lastDisconnectedAt": "Last DisconnectedAt",
    "frontendUserPrimaryFieldAuth.isActive": "isActive",
    "frontendUserPrimaryFieldAuth.createdWay": "Created Way",
    "frontendUserPrimaryFieldAuth.entityId": "Entity Id",

    "cardList.id": "Id",
    "cardList.cardno": "Card No",
    "cardList.type": "Type",
    "cardList.merchantId": "Merchant Id",
    "cardList.userId": "User Id",
    "cardList.email": "Email",
    "cardList.phone": "Phone",
    "cardList.status": "Status",
    "cardList.profileId": "Profile Id",
    "cardList.createdAt": "Card Created",
    "cardList.updatedAt": "Last Modified",
    "cardList.action": "Action",

    "login.panelName": "Login",
    "login.loginBtn": "Login",
    "login.panelRightSpan": "Don’t have an account?",
    "login.panelRightSpanButton": "Register a new account",
    "login.rememberMeLabel": "Remember me",
    "login.forgetBtn": "Forget the password ?",

    "passwordForget.passwordReset": "Password Reset",
    "passwordForget.panelRightSpan": "We Will Help You Reset your Password",
    "passwordForget.rememberedPassword": "Remembered your Password?",
    "passwordForget.navigateBack": "Back to Sign In",
    "passwordForget.label_code": "Verification Code",
    "passwordForget.placeholder_code": "Verification Code",

    "passwordReset.passwordReset": "Password Reset",
    "passwordReset.panelRightSpan": "We Will Help You Reset your Password",
    "passwordReset.rememberedPassword": "Remembered your Password?",
    "passwordReset.navigateBack": "Back to Sign In",
    "passwordReset.passwordNotMatch": "The new password that you entered do not match!",

    "passwordResetSuccess.successful": "Successful",
    "passwordResetSuccess.panelRightSpan": "The password has been changed successfully",
    "passwordResetSuccess.navigateBack": "Back to Sign In",

    "homeMenu.dashboard": "Dashboard",
    "homeMenu.customer": "Customer",
    "homeMenu.allCustomers": "All Customers",
    "homeMenu.campaign": "Campaign",
    "homeMenu.campaigns": "Campaigns",
    "homeMenu.campaignSettings": "Settings",
    "homeMenu.reports": "Reports",
    "homeMenu.main": "Main",
    "homeMenu.push": "Push",
    "homeMenu.company": "Company",
    "homeMenu.role": "Role",
    "homeMenu.user": "Users",
    "homeUser.loginout": "Sign Out",
    "homeUser.profile": "Profile",
    "homeMenu.allUsers": "Users",
    "homeMenu.users": "Users",
    "homeMenu.merchants": "Merchants",
    "homeMenu.merchantUsers": "Merchant Users",
    "homeMenu.merchantService": "Merchant Service",
    "homeMenu.serviceAlias": "Service Alias",
    "homeMenu.serviceInstance": "Service Instance",
    "homeMenu.servicePlan": "Service Plan",
    "homeMenu.adminRole": "Admin Role",
    "homeMenu.operationLog": "Operation Log",
    "homeMenu.merchantsVendor": "Merchants Vendor",
    "homeMenu.frontendUser": "Frontend User",
    "homeMenu.frontendUserPrimaryFieldAuth": "Primary Field Auth",
    "homeMenu.notification": "Notification",
    "homeMenu.configData": "Config Data",
    "homeMenu.merchantCards": "Cards",
    "homeMenu.merchantCardField": "Card Field",
    "userProfile.profileTitle": "User Profile",

    "router.dashboard": "Dashboard",
    "router.users": "Users",
    "router.merchants": "Merchants",
    "router.merchantUsers": "Merchant Users",
    "router.merchantService": "Merchant Service",
    "router.serviceAlias": "Service Alias",
    "router.serviceInstance": "Service Instance",
    "router.servicePlan": "Service Plan",
    "router.adminRole": "Admin Role",
    "router.operationLog": "Operation Log",
    "router.PageNotFound": "Page Not Found",
    "router.merchantsVendor": "Merchants Vendor",
    "router.login": "Login",
    "router.forgetpassword": "Forget password",
    "router.resetpassword": "Reset password",
    "router.passwordResetSuccess": "Reset password success",
    "router.frontendUser": "Frontend User",
    "router.frontendUserPrimaryFieldAuth": "Frontend User Primary Field Auth",
    "router.merchantCardField": "Card Field",
    "router.merchantCards": "Merchant Cards",
    "router.notification": "Notification",

    "pageNotFound.pageNotFound": "Page Not Found",

    "DashboardHeader.labelTips": "Let’s get creative with E-Com365 Go CRM Micro-service to organize your content.",
    "DashboardHeader.panelLeftTitle": "Welcome back to E-Com365 Go CRM Micro-service",

    "Customer.pushBtn": "Push Message",
    "Customer.pushPromoBtn": "Push Promotion",
    "Customer.findBtnLabel": "Find",
    "Customer.chooseCompany": "click the button to select company",
    "Customer.addCustomerTitle": "Create Customer",
    "Customer.editCustomerTitle": "Edit Customer",
    "Customer.detailCustomerTitle": "Detail Customer",
    "Customer.selectCompanyTitle": "Select Company",
    "Customer.editPushMessage": "set push message",
    "Customer.pushModal.okBtn": "Send",
    "customer.confirmModalDelMsg": "Are you sure to delete {name} with {key} equal {val}?",
    "customer.selectCompanyWarning": "please select company!",
    "customer.confirmModalPromoMsg": "Are you sure to push promotion message to these {val} users?",
    "customer.addFirstCustomerTitle": "Add First Customer",
    "customer.addFirstCustomerLabel1": "Having a customer list helps to know your audience better.",
    "customer.addFirstCustomerLabel2": "Manage your customers in one place and target your audinece better.",
    "customer.addFirstCustomer": "Add Customer",
    "customer.addFirstCustomerReadMore": "Read More",

    "createCustomer.backLabel": "Back",

    "detailCustomer.editInfoButton": "Edit information",

    "campaigns.addNewCampaignLabel": "Create New Campaigns",
    "campaigns.saveButton": "Save Campaign",
    "campaigns.editCampaignLabel": "Edit The Campaign",
    "campaigns.sendCampaignLabel": "Send Campaign",

    "exports.exportButton": "Export",
    "exports.customerGrowth": "Customer Growth",
    "exports.salesGoal": "Sales Goal",
    "exports.conversionRate": "Conversion Rate",
    "exports.storeFunnel": "Store Funnel",
    "exports.ageDistribution": "Age Distribution",
    "exports.averageOrderValue": "Average Order Value",

    "Message.PushDetailTitle": "Push Detail",
    "Message.PushTargetTitle": "Push Target",
    "Message.notFoundDetail": "Message Not Found",
    "MessageModal.text_isRequired": "Please input a text or delete this field.",

    "pushModal.addTextBtn": "add text",
    "pushModal.addImageBtn": "Upload Image",
    "pushModal.addImagePlaceHolder": "input the image link or upload the file(png/jpg/jpeg), multiple links are separated by [ , ]",
    "pushModal.uploadImageTypeError": "{name} is not a valid image",
    "pushModal.addVideoBtn": "Upload Video",
    "pushModal.addVideoPlaceHolder": "input the video link or upload the file(mp4/avi/mov/flv), multiple links are separated by [ , ]",
    "pushModal.uploadVideoTypeError": "{name} is not a valid video",
    "pushModal.addDocumentBtn": "Upload Document",
    "pushModal.addDocumentPlaceHolder": "input the document link or upload the file(doc/docx/pdf/xls/xlsx/ppt/pptx), multiple links are separated by [ , ]",
    "pushModal.uploadDocumentTypeError": "{name} is not a valid document",
    "pushModal.uploadSize": "max size cannot exceed 30MB",

    "userManage.users": "Users",
    "userManage.role": "Role",
    "userManage.email": "Email",
    "userManage.createAt": "Account Created",
    "userManage.updatedAt": "Last Modified",
    "userManage.action": "Action",
    'userManage.addUserTitle': "Create User",
    'userManage.editUserTitle': "Edit User",
    "userManage.addBtn": "Add one user",
    "userManage.manageRolePermissionsBtn": "Manage role permissions",
    "userManage.totalsSummary": "Showing {from} to {to} of {total} results",
    "userManage.filterBtn": "Filter",
    "userManage.first_name": "Firstname",
    "userManage.last_name": "Lastname",
    "userManage.email": "Email",
    "userManage.role_id": "Role",
    "userManage.activeFilters": "Active Filters:",
    "userManage.deleteUser": "Delete User",
    "userManage.confirmModalDelMsg": "Are you sure to delete user data with email equal {email}?",

    "merchants.addBtn": "Create New Merchant",
    "merchants.filterBtn": "filter",
    "merchants.activeFilters": "Active Filters:",
    'merchants.addMerchantTitle': "Create Merchant",
    'merchants.editMerchantTitle': "Edit Merchant",
    "merchants.merchantName": "Merchant Name",
    "merchants.merchant_name": "Merchant Name",
    "merchants.merchantCode": "Merchant Code",
    "merchants.merchant_code": "Merchant Code",
    "merchants.merchantFrontendUrl": "Merchant Frontend Url",
    "merchants.entityId": "Entity Id",
    "merchants.timeZone": "Time Zone",
    "merchants.isActive": "Is Active",
    "merchants.contactEmail": "Contact Email",
    "merchants.email": "Email",
    "merchants.createdWay": "Created Way",
    "merchants.contact_email": "Email",
    "merchants.contactPhone": "Phone",
    "merchants.contact_phone": "Phone",
    "merchants.createdAt": "Account Created",
    "merchants.updatedAt": "Last Modified",
    "merchants.action": "Action",
    "merchants.totalsSummary": "Showing {from} to {to} of {total} results",

    "merchants.timeZone": "Time Zone",
    "merchants.deleteMerchant": "Delete Merchant",
    "merchants.confirmModalDelMsg": "Are you sure to delete merchant data with email equal {email}?",

    "merchantDetail.merchantCards": "Merchant Cards",
    "merchantDetail.merchantCardField": "Merchant Card Field",
    "merchantDetail.MerchantConfigData": "Merchant Config Data",
    "merchantDetail.merchantConfigData": "Merchant Config Data",
    "merchantDetail.overView": "Over View",
    "merchantDetail.serviceInstance": "Service Instance",
    "merchantDetail.userManagement": "User Management",
    "merchantDetail.MerchantService": "Merchant Service",
    "merchantDetail.merchantVendor": "Merchant Vendor",
    "merchantDetail.back": "Back",
    "merchantDetail.notification": "Notification",

    "merchantUsers.users": "Users",
    "merchantUsers.role": "Role",
    "merchantUsers.email": "Email",
    "merchantUsers.createdAt": "Account Created",
    "merchantUsers.updatedAt": "Last Modified",
    "merchantUsers.action": "Action",
    'merchantUsers.addUserTitle': "Create User",
    'merchantUsers.editUserTitle': "Edit User",
    "merchantUsers.addBtn": "Add one user",
    "merchantUsers.manageRolePermissionsBtn": "Manage role permissions",
    "merchantUsers.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantUsers.filterBtn": "Filter",
    "merchantUsers.email": "Email",
    "merchantUsers.merchant_id": "Merchant name",
    "merchantUsers.activeFilters": "Active Filters:",
    "merchantUsers.merchantCompany": "Merchant name",
    "merchantUsers.deleteMerchantUser": "Delete Merchant User",
    "merchantUsers.confirmModalDelMsg": "Are you sure to delete merchant user data with email equal {email}?",
    "merchantUsers.userName": "User Name",
    "merchantUsers.user_name": "User Name",
    "merchantUsers.merchantName": "Merchant Name",
    "merchantUsers.permissionTitle": "{userName} permission",
    "merchantUsers.userId": "User Id",

    "merchantCards.addBtn": "Create New Card",
    "merchantCards.filterBtn": "Filter",
    "merchantCards.activeFilters": "Active Filters:",
    'merchantCards.addMerchantTitle': "Create Card",
    'merchantCards.editMerchantTitle': "Edit Card",
    "merchantCards.email": "Email",
    "merchantCards.createdAt": "Card Created",
    "merchantCards.updatedAt": "Last Modified",
    "merchantCards.action": "Action",
    "merchantCards.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantCards.cardNo": "Card No",
    "merchantCards.cardno": "Card No",
    "merchantCards.active": "Active",
    "merchantCards.merchants": "Merchants",
    "merchantCards.deleteCard": "Delete Card",
    "merchantCards.confirmModalDelMsg": "Are you sure to delete merchant data with id equal {id}?",
    "merchantCards.id": "Id",
    "merchantCards.phone": "Phone",
    "merchantCards.status": "Status",
    "merchantCards.expiredAt": "Expired At",
    "merchantCards.addCardtTitle": "Create Card",
    "merchantCards.editCardTitle": "Edit Card",

    "merchantCardField.addBtn": "Create New Card Field",
    "merchantCardField.filterBtn": "filter",
    "merchantCardField.activeFilters": "Active Filters:",
    'merchantCardField.addMerchantTitle': "Create Card Field",
    'merchantCardField.editMerchantTitle': "Edit Card Field",
    "merchantCardField.createdAt": "Plan Created",
    "merchantCardField.updatedAt": "Last Modified",
    "merchantCardField.action": "Action",
    "merchantCardField.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantCardField.active": "Active",
    "merchantCardField.plan_name": "Plan name",
    "merchantCardField.deleteCardField": "Delete Card Field",
    "merchantCardField.confirmModalDelMsg": "Are you sure to delete card field data with field code equal {fieldCode}?",
    "merchantCardField.merchants": "Merchant Name",
    "merchantCardField.fieldCode": "Field Code",
    "merchantCardField.field_code": "Field Code",
    "merchantCardField.fieldType": "Field Type",
    "merchantCardField.field_type": "Field Type",
    "merchantCardField.isPrimary": "Is Primary",
    "merchantCardField.is_primary": "Is primary",
    "merchantCardField.isRequestMandatory": "Is Request Mandatory",
    "merchantCardField.is_request_mandatory": "Is request mandatory",
    "merchantCardField.addCardField": "Create Card Field",
    "merchantCardField.editCardField": "Edit Card Field",

    "merchantNotification.addBtn": "Create Notification",
    "merchantNotification.addNotification": "Add Notification",
    "merchantNotification.filterBtn": "filter",
    "merchantNotification.activeFilters": "Active Filters:",
    'merchantNotification.addMerchantTitle': "Create Card Field",
    'merchantNotification.editMerchantTitle': "Edit Card Field",
    "merchantNotification.createdAt": "Plan Created",
    "merchantNotification.updatedAt": "Last Modified",
    "merchantNotification.action": "Action",
    "merchantNotification.totalsSummary": "Showing {from} to {to} of {total} results",
    "merchantNotification.active": "Active",
    "merchantNotification.plan_name": "Plan name",
    "merchantNotification.deleteCardField": "Delete Card Field",
    "merchantNotification.confirmModalDelMsg": "Are you sure to delete notification with id equal {id}?",
    "merchantNotification.merchants": "Merchant Name",
    "merchantNotification.title": "Title",
    "merchantNotification.content": "Content",
    "merchantNotification.isPrimary": "Is Primary",
    "merchantNotification.is_primary": "Is primary",
    "merchantNotification.isRequestMandatory": "Is Request Mandatory",
    "merchantNotification.is_request_mandatory": "Is request mandatory",
    "merchantNotification.addCardField": "Create Card Field",
    "merchantNotification.editCardField": "Edit Card Field",
    "merchantNotification.ofTheseMatch1": "of these Conditions match:",
    "merchantNotification.if": "If",
    "merchantNotification.isTrigger": "Is Trigger",
    "merchantNotification.isTrigger": "Is Trigger",


    "adminRole.addBtn": "Create New Role",
    "adminRole.filterBtn": "filter",
    "adminRole.activeFilters": "Active Filters:",
    'adminRole.addMerchantTitle': "Create role",
    'adminRole.editMerchantTitle': "Edit role",
    "adminRole.createdAt": "Service Created",
    "adminRole.updatedAt": "Last Modified",
    "adminRole.action": "Action",
    "adminRole.totalsSummary": "Showing {from} to {to} of {total} results",
    "adminRole.entityId": "Entity Id",
    "adminRole.active": "Active",
    "adminRole.roleName": "Role Name",
    "adminRole.permission": "Permission",
    "adminRole.permissionTitle": "{roleName} permission",
    "adminRole.role_name": "Role name",
    "adminRole.deleteRole": "Delete Role",
    "adminRole.confirmModalDelMsg": "Are you sure to delete role data with role name equal {roleName}?",

    "systemOperationLog.filterBtn": "filter",
    "systemOperationLog.activeFilters": "Active Filters:",
    "systemOperationLog.Username": "User name",
    "systemOperationLog.UserRoleName": "User role name",
    "systemOperationLog.ActionName": "Action name",
    "systemOperationLog.IsSuccess": "Is success",
    "systemOperationLog.CreatedAt": "Created At",
    "systemOperationLog.UpdatedAt": "Updated At",
    "systemOperationLog.Id": "Id",
    "systemOperationLog.viewMore": "View More",
    "systemOperationLog.action": "Action",
    "systemOperationLog.ActionContent": "Action Content",
    "systemOperationLog.totalsSummary": "Showing {from} to {to} of {total} results",


}
export {
    en_US
}   